import { lazy } from "react";
import { HomePage, DisplayDataPage, ProfilePage } from "./pages";
import RelatoriosDisplay from "./pages/RelatoriosDisplay";
import { perfisDaRota } from "./telasDormentes";

const ParametrosProtestoBox = lazy(() => import("./pages/protesto/ParametrosProtestoBox"));
const MunicipiosHomologadosBox = lazy(() => import("./pages/protesto/MunicipiosHomologadosBox"));
const RegistroIntegracaoBox = lazy(() => import("./pages/protesto/RegistroIntegracaoBox"));
const PedidosProtestoBox = lazy(() => import("./pages/protesto/PedidosProtestoBox"));
const RemessasProtestoBox = lazy(() => import("./pages/protesto/RemessasProtestoBox"));
const AcompanhamentoProtestoBox = lazy(() => import("./pages/protesto/AcompanhamentoProtestoBox"));
const EncerramentosProtestoBox = lazy(() => import("./pages/protesto/EncerramentosProtestoBox"));
const MotivosEncerramentoBox = lazy(() => import("./pages/protesto/MotivosEncerramentoBox"));
const ContribuintesNovoBox = lazy(() => import("./pages/contribuintesNovo/ContribuintesNovoBox"));
const ContribuinteNovoFormulario = lazy(() => import("./pages/contribuintesNovo/ContribuinteFormulario"));
const JurosBox = lazy(() => import("./pages/JurosBox"));
const CalendarioIssBox = lazy(() => import("./pages/CalendarioIssBox"));
const CategoriaCpbxBox = lazy(() => import("./pages/CategoriaCpbsBox"));
const ServicosIssBox = lazy(() => import("./pages/servicosIss/ServicosIssBox"));
const ContadorBox = lazy(() => import("./pages/contadores/ContadorBox"));
const ContadorForm = lazy(() => import("./pages/contadores/ContadorForm"));
const MultasBox = lazy(() => import("./pages/MultasBox"));
const BairrosBox = lazy(() => import("./pages/BairrosBox"));
const DistritosBox = lazy(() => import("./pages/DistritosBox"));
const EscoresBox = lazy(() => import("./pages/EscoresBox"));
const AliquotasIPTUBox = lazy(() => import("./pages/AliquotasIPTUBox"));
const LogradourosBox = lazy(() => import("./pages/LogradourosBox"));
const LoteamentosBox = lazy(() => import("./pages/LoteamentosBox"));
const ColaboradoresBox = lazy(() => import("./pages/ColaboradoresBox"));
const CategoriasAliquotasIssBox = lazy(() => import("./pages/CategoriasAliquotasIssBox"));
const SituacoesCadastraisCpbsBox = lazy(() => import("./pages/SituacoesCadastraisCpbsBox"));
const RegimesTributariosBox = lazy(() => import("./pages/RegimesTributariosBox"));
const TiposRecolhimentoBox = lazy(() => import("./pages/TiposRecolhimentoBox"));
const GrausInstrucaoBox = lazy(() => import("./pages/GrausIntrucaoBox"));
const NaturezasJuridicasBox = lazy(() => import("./pages/NaturezasJuridicasBox"));
const CnaesBox = lazy(() => import("./pages/CnaesBox"));
const FeriadosBox = lazy(() => import("./pages/FeriadosBox"));
const PrefeituraBox = lazy(() => import("./pages/prefeituras/PrefeituraBox"));
const PrefeituraForm = lazy(() => import("./pages/prefeituras/PrefeituraForm"));
const ServicosLCPBox = lazy(() => import("./pages/ServicosLCPBox"));
const CategoriasLCPBox = lazy(() => import("./pages/CategoriasLCPBox"));
const NaturezasOperacaoBox = lazy(() => import("./pages/NaturezasOperacaoBox"));
const SerieNotaFiscalBox = lazy(() => import("./pages/SerieNotaFiscalBox"));
const RetencaoExternaBox = lazy(() => import("./pages/RetencaoExternaBox"));
const CadastrarLeisBox = lazy(() => import("./pages/CadastrarLeisBox"));
const DocumentosRetencaoBox = lazy(() => import("./pages/DocumentosRetencaoBox"));
const CpbsBox = lazy(() => import("./pages/cpbs/CpbsBox"));
const CpbsForm = lazy(() => import("./pages/cpbs/CpbsForm"));
const TextoCdaBox = lazy(() => import("./pages/textoCda/TextoCdaBox"));
const TextoCdaForm = lazy(() => import("./pages/textoCda/TextoCdaForm"));
const AgentesRecebedoresBox = lazy(() => import("./pages/AgentesRecebedoresBox"));
const TiposVeiculosBox = lazy(() => import("./pages/TiposVeiculosBox"));
const SituacaoDividaBox = lazy(() => import("./pages/SituacaoDividaBox"));
const TipoNotificacaoBox = lazy(() => import("./pages/tipoNotificacao/TipoNotificacaoBox"));
const TipoNotificacaoForm = lazy(() => import("./pages/tipoNotificacao/TipoNotificacaoForm"));
const VeiculosBox = lazy(() => import("./pages/veiculos/VeiculosBox"));
const VeiculosForm = lazy(() => import("./pages/veiculos/VeiculosForm"));
const ContasBancariasBox = lazy(() => import("./pages/contasBancarias/ContasBancariasBox"));
const ContasBancariasForm = lazy(() => import("./pages/contasBancarias/ContasBancariasForm"));
const ReceitasBox = lazy(() => import("./pages/receitas/ReceitasBox"));
const ReceitasForm = lazy(() => import("./pages/receitas/ReceitasForm"));
const UnidadeFiscalBox = lazy(() => import("./pages/UnidadeFiscalBox"));
const ContribuinteBox = lazy(() => import("./pages/contribuintes/ContribuinteBox"));
const ContribuinteForm = lazy(() => import("./pages/contribuintes/ContribuinteForm"));
const ParametrosRefisBox = lazy(() => import("./pages/parametosRefis/ParametrosRefisBox"));
const ParametrosRefisForm = lazy(() => import("./pages/parametosRefis/ParametrosRefisForm"));
const IndicePrecosBox = lazy(() => import("./pages/IndicePrecosBox"));
const CentralRelatorios = lazy(() => import("./pages/centralRelatorios/CentralRelatorios"));
const FatoresCorrecaoMonetariaBox = lazy(() => import("./pages/fatoresCorrecaoMonetaria/FatoresCorrecaoMonetariaBox"));
const SegmentosBox = lazy(() => import("./pages/segmentos/SegmentosBox"));
const SegmentosForm = lazy(() => import("./pages/segmentos/SegmentosForm"));
const FatoresCorretivosBox = lazy(() => import("./pages/fatoresCorretivos/FatoresCorretivosBox"));
const FatoresCorretivosForm = lazy(() => import("./pages/fatoresCorretivos/FatoresCorretivosForm"));
const TaxasBox = lazy(() => import("./pages/taxas/TaxasBox"));
const TaxasForm = lazy(() => import("./pages/taxas/TaxasForm"));
const ConfiguracaoCndBox = lazy(() => import("./pages/configuracaoCnd/ConfiguracaoCndBox"));
const ConfiguracaoCndForm = lazy(() => import("./pages/configuracaoCnd/ConfiguracaoCndForm"));
const MotivoIsensaoIptuBox = lazy(() => import("./pages/MotivoIsensaoIptuBox"));
const ImovelBox = lazy(() => import("./pages/imovel/ImovelBox"));
const ImovelForm = lazy(() => import("./pages/imovel/ImovelForm"));
const DiatBox = lazy(() => import("./pages/dividaAtiva/DiatBox"));
const DiatForm = lazy(() => import("./pages/dividaAtiva/DiatForm"));
const NotificacaoDiatBox = lazy(() => import("./pages/notificacaoDivida/NotificacaoDiatBox"));
const NotificacaoDiatForm = lazy(() => import("./pages/notificacaoDivida/NotificacaoDiatForm"));
const EntregaNotificacaoDiatBox = lazy(() => import("./pages/EntregaNotificacaoDivida/EntregaNotificacaoDiatBox"));
const EntregaNotificacaoDiatForm = lazy(() => import("./pages/EntregaNotificacaoDivida/EntregaNotificacaoDiatForm"));
const CuboImoveis = lazy(() => import("./pages/cuboImoveis/CuboImoveis"));
const ArrecadacaoPopup = lazy(() => import("./pages/ArrecadacaoPopup"));
const ImoveisInativosPopup = lazy(() => import("./pages/ImoveisInativosPopup"));
const ImprimirImoveisPopup = lazy(() => import("./pages/ImprimirImoveisPopup"));
const RelatoriosFiltros = lazy(() => import("./pages/RelatoriosFiltros"));
const FormEditTerreno = lazy(() => import("./pages/imovel/options/infoTerreno"));
const FormEditEdificacao = lazy(() => import("./pages/imovel/options/infoEdificacao"));
const AlvaraVeiculoForm = lazy(() => import("./pages/lancamentos/AlvaraVeiculo"));
const DamsBox = lazy(() => import("./pages/DamsBox"));
const CefsBox = lazy(() => import("./pages/CefsBox"));
const AlvarasBox = lazy(() => import("./pages/lancamentos/AlvarasBox"));
const EnviarArquivoProcessamento = lazy(() => import("./pages/EnviarArquivoProcessamento"));
const LancamentoIptu = lazy(() => import("./pages/lancamentos/lancamentoIptu/LancamentoIptuBox"));
const ImprimirIptu = lazy(() => import("./pages/iptu/ImprimirIptu"));
const ParametrosIptuBox = lazy(() => import("./pages/parametrosIptu/ParamIptuBox"));
const ParametrosIptuForm = lazy(() => import("./pages/parametrosIptu/ParamIptuForm"));
const BaixaManualForm = lazy(() => import("./pages/BaixaManual"));
const BaixarNotas = lazy(() => import("./pages/lancamentos/BaixarNotas"));
const TipoUsoLogradouroBox = lazy(() => import("./pages/TipoUsoLogradouroBox"));
const TiposAlvaraConstrucaoForm = lazy(() => import("./pages/tiposAlvaraConstrucao/TiposAlvaraConstrucaoForm"));
const TiposAlvaraConstrucaoBox = lazy(() => import("./pages/tiposAlvaraConstrucao/TiposAlvaraConstrucaoBox"));
const TipoAlvaraDiversoForm = lazy(() => import("./pages/tipoAlvaraDiverso/TipoAlvaraDiversoForm"));
const TipoAlvaraDiversoBox = lazy(() => import("./pages/tipoAlvaraDiverso/TipoAlvaraDiversoBox"));
const LancamentoAlvaraHorarioEspecial = lazy(() => import("./pages/alvaras/LancamentoAlvaraHorarioEspecial"));
const LancamentoUsoLogradouroPublico = lazy(() => import("./pages/alvaras/LancamentoUsoLogradouroPublico"));
const LancamentoAlvaraPublicidade = lazy(() => import("./pages/alvaras/LancamentoAlvaraPublicidade"));
const LancamentoAlvaraDiversos = lazy(() => import("./pages/alvaras/LancamentoAlvaraDiversos"));
const LancamentoAlvaraConstrucao = lazy(() => import("./pages/alvaras/LancamentoAlvaraConstrucao"));
const ItbiForm = lazy(() => import("./pages/itbi/ItbiForm"));
const NegociacaoDiat = lazy(() => import("./pages/negociacaoDividaAtiva/NegociacaoDiat"));
const CnaePrefeituraBox = lazy(() => import("./pages/cnaePrefeitura/CnaePrefeituraBox"));
const CnaePrefeituraForm = lazy(() => import("./pages/cnaePrefeitura/CnaePrefeituraForm"));
const Lcp116PrefeituraBox = lazy(() => import("./pages/lcp116Prefeitura/Lcp116PrefeituraBox"));
const Lcp116PrefeituraForm = lazy(() => import("./pages/lcp116Prefeitura/Lcp116PrefeituraForm"));
const CategoriaLcp116PrefeituraBox = lazy(() => import("./pages/CategoriaLcp116PrefeituraBox"));
const AlvaraFuncionamentoForm = lazy(() => import("./pages/lancamentos/AlvaraFuncionamentoForm"));
const SociosBox = lazy(() => import("./pages/cpbs/Socios/SociosBox"));
const SociosForm = lazy(() => import("./pages/cpbs/Socios/SociosForm"));
const FormulasBox = lazy(() => import("./pages/formulasIptu/FormulasBox"));
const FormulasForm = lazy(() => import("./pages/formulasIptu/FormulasForm"));
const QualificacaoSociosBox = lazy(() => import("./pages/QualificacaoSociosBox"));
const ConfigBox = lazy(() => import("./pages/ConfigBox"));
const PrecoPublicoBox = lazy(() => import("./pages/precoPublico/PrecoPublicoBox"));
const PrecoPublicoForm = lazy(() => import("./pages/precoPublico/PrecoPublicoForm"));
const PermissionarioBox = lazy(() => import("./pages/permissionario/PermissionarioBox"));
const PermissionarioForm = lazy(() => import("./pages/permissionario/PermissionarioForm"));
const ResponsavelTecnicoBox = lazy(() => import("./pages/responsavelTecnico/ResponsavelTecnicoBox"));
const ResponsavelTecnicoForm = lazy(() => import("./pages/responsavelTecnico/ResponsavelTecnicoForm"));
const CertidaoNegativaBox = lazy(() => import("./pages/certidaoNegativa/CertidaoNegativaBox"));
const CertidaoNegativaForm = lazy(() => import("./pages/certidaoNegativa/CertidaoNegativaForm"));
const CertidaoNegativaAutomatica = lazy(() => import("./pages/certidaoNegativa/CertidaoNegativaAutomatica"));
const VisualizarCertidao = lazy(() => import("./pages/certidaoNegativa/VisualizarCertidao"));
const ItbiBox = lazy(() => import("./pages/itbi/ItbiBox"));
const LancamentoTaxasForm = lazy(() => import("./pages/lancamentoTaxas/LancamentoTaxasForm"));
const LancamentoTaxasBox = lazy(() => import("./pages/lancamentoTaxas/LancamentoTaxasBox"));
const ValorEdificadoBox = lazy(() => import("./pages/valorEdificado/ValorEdificadoBox"));
const ValorEdificadoForm = lazy(() => import("./pages/valorEdificado/ValorEdificadoForm"));
const AcompanhamentoDiatBox = lazy(() => import("./pages/AcompanhamentoDiatBox"));
const NotaFiscalAvulsaBox = lazy(() => import("./pages/notaFiscalAvulsa/NotaFiscalAvulsaBox"));
const NotaFiscalAvulsaForm = lazy(() => import("./pages/notaFiscalAvulsa/NotaFiscalAvulsaForm"));
const CdaBox = lazy(() => import("./pages/cda/CdaBox"));
const CnaesCpbsBox = lazy(() => import("./pages/cpbs/Cnaes/CnaesCpbsBox"));
const Habitese = lazy(() => import("./pages/habitese/habitese"));
const DetalheLanchamento = lazy(() => import("./pages/lancamentos/DetalheLancamento"));
const AcompanharProcessamento = lazy(() => import("./pages/processamentos/AcompanharProcessamento"));
const ListarProcessamento = lazy(() => import("./pages/processamentos/ListarProcessamentos"));
const DetalheNFAvulsa = lazy(() => import("./pages/notaFiscalAvulsa/DetalheNFAvulsa"));
const CdaForm = lazy(() => import("./pages/cda/CdaForm"));
const ServicosIssForm = lazy(() => import("./pages/servicosIss/ServicosIssForm"));
const ConferenciaAcordo = lazy(() => import("./pages/ConferenciaAcordo"));
const PrescricaoDiat = lazy(() => import("./pages/PrescricaoDiat"));
const FaturamentoPermissionarios = lazy(() => import("./pages/permissionario/FaturamentoPermissionarios"));
const ProtocoloEntregaNotificacao = lazy(() => import("./pages/notificacaoDivida/ProtocoloEntregaNotificacaoForm"));
const CadastroProcessamentosTeste = lazy(() => import("./pages/CadastroProcessamentosTeste"));
const UsuariosBox = lazy(() => import("./pages/usuarios/UsuariosBox"));
const UsuariosForm = lazy(() => import("./pages/usuarios/UsuariosForm"));
const AnaliseGraficos = lazy(() => import("./pages/analises/analiseGraficos"));
const EnviarAcessosEmMassa = lazy(() => import("./pages/EnviarAcessoEmMassa"));
const ArquivosEBoletos = lazy(() => import("./pages/ArquivosEBoletos"));
const FerramentasNFSe = lazy(() => import("./pages/Ferramentas NFS-e"));
const MenuConfiguracoes = lazy(() => import("./pages/menuConfiguracoes/MenuConfiguracoes"));
const ContasCosifBox = lazy(() => import("./pages/contasCosif/ContasCosifBox"));
const ContasCosifForm = lazy(() => import("./pages/contasCosif/ContasCosifForm"));
const UploadFiles = lazy(() => import("./pages/uploadFiles/UploadFiles"));
const ExtratoDebitos = lazy(() => import("./pages/relatorios/ExtratoDebitos"));
const NfseBox = lazy(() => import("./pages/NfseBox"));
const NfseGradeBox = lazy(() => import("./pages/NfseGradeBox"));
const PainelImobiliarioBox = lazy(() => import("./pages/PainelImobiliarioBox"));
const CalculoManualDiatBox = lazy(() => import("./pages/calculoManualDiat/CalculoManualDiatBox"));
const CalculoManualDiatForm = lazy(() => import("./pages/calculoManualDiat/CalculoManualDiatForm.js"));
const UsuariosPrefeituraBox = lazy(() => import("./pages/usuariosPrefeitura/usuariosPrefeitura"));
const RecursoBox = lazy(() => import("./pages/recurso/RecursoBox.js"));
const RecursoForm = lazy(() => import("./pages/recurso/RecursoForm.js"));
const GrupoRecursoBox = lazy(() => import("./pages/grupoRecurso/GrupoRecursoBox.js"));
const GrupoRecursoForm = lazy(() => import("./pages/grupoRecurso/GrupoRecursoForm.js"));
const StatusProtocoloBox = lazy(() => import("./pages/statusProtocolo/StatusProtocoloBox.js"));
const StatusProtocoloForm = lazy(() => import("./pages/statusProtocolo/StatusProtocoloForm.js"));
const SetorAtendimentoProtocoloForm = lazy(() => import("./pages/setorAtendimentoProtocolo/SetorAtendimentoProtocoloForm.js"));
const SetorAtendimentoProtocoloBox = lazy(() => import("./pages/setorAtendimentoProtocolo/SetorAtendimentoProtocoloBox.js"));
const TipoProtocoloBox = lazy(() => import("./pages/tipoProtocolo/TipoProtocoloBox.js"));
const TipoProtocoloForm = lazy(() => import("./pages/tipoProtocolo/TipoProtocoloForm.js"));
const AuditoriaBox = lazy(() => import("./pages/AuditoriaBox.js"));
const IssFixo = lazy(() => import("./pages/issFixo//IssFixo.js"));
const PermissoesBox = lazy(() => import("./pages/usuariosPrefeitura/PermissoesBox.js"));
const ProtocolosBox = lazy(() => import("./pages/ProtocolosBox"));
const CalculoIptu = lazy(() => import("./pages/imovel/options/calculoIptu"));
const SimplesNacionalBox = lazy(() => import("./pages/SimplesNacionalBox.js"));
const ProcedimentoDiat = lazy(() => import("./pages/ProcedimentoDiat.js"));
const Simulacoes = lazy(() => import("./pages/simulacoes"));
const GerarLivro = lazy(() => import("./pages/GerarLivro.js"));
const UnificacaoCadastrosBox = lazy(() => import("./pages/UnificacaoCadastrosBox.js"));
const ImobelBciBox = lazy(() => import("./pages/imovelBci/ImovelBciBox"));
const ImovelBciForm = lazy(() => import("./pages/imovelBci/ImovelBciForm"));
const ImovelBciFatores = lazy(() => import("./pages/imovelBci/ImovelBciFatoers"));
const PreMigracaoCpbsBox = lazy(() => import("./pages/PreMigracaoCpbsBox.js"));
const IndicesTrimapBox = lazy(() => import("./pages/IndicesTrimapBox.js"));
const CalendarioIndicesTrimapBox = lazy(() => import("./pages/CalendarioIndicesTrimapBox.js"));
const Graficos = lazy(() => import("./pages/graficos"));
const EncerramentoFiscalManualBox = lazy(() => import("./pages/encerramentoFiscal/EncerramentoFiscalManualBox"));
const EncerramentoFiscalManualForm = lazy(() => import("./pages/encerramentoFiscal/EncerramentoFiscalManualForm"));
const AcompanhamentoSNBox = lazy(() => import("./pages/acompanhamentoSimplesNacional/AcompanhamentoSNBox"));
const PainelIssBox = lazy(() => import("./pages/painelIss/PainelIssBox"));
const DiatFormNovo = lazy(() => import("./pages/dividaAtiva/DiatFormNovo"));
const RegistrarBoletosBox = lazy(() => import("./pages/RegistrarBoletosBox"));
const LancamentoIptuForm = lazy(() => import("./pages/lancamentos/lancamentoIptu/LancamentoIptuForm"));
const AcompanharIptu = lazy(() => import("./pages/lancamentos/lancamentoIptu/AcompanharIptu"));
const TransferenciaAnualDiat = lazy(() => import("./pages/diatTransferenciaAnual/TransferenciaAnualDiat"));
const ParametrosLivroBox = lazy(() => import("./pages/diatLivros/parametrosLivroDiat/ParametrosLivroBox"));
const ParametrosLivroForm = lazy(() => import("./pages/diatLivros/parametrosLivroDiat/ParametrosLivroForm"));
const GerarLivroDiat = lazy(() => import("./pages/diatLivros/gerarLivrosDiat/GerarLivroDiat"));
const ExtratoDebitosDiatBox = lazy(() => import("./pages/extratoDebitosDiat/ExtratoDebitosDiatBox"));
const CadastroModelosBox = lazy(() => import("./pages/CadastroModelos/CadastroModelosBox"));
const CadastroModelosForm = lazy(() => import("./pages/CadastroModelos/CadastroModelosForm"));
const CadastroModelosPrefeituraBox = lazy(() => import("./pages/CadastroModelosPrefeitura/CadastroModelosPrefeituraBox"));
const CadastroModelosPrefeituraForm = lazy(() => import("./pages/CadastroModelosPrefeitura/CadastroModelosPrefeituraForm"));
const ParametrosPixBox = lazy(() => import("./pages/parametrosPix/ParametrosPixBox"));
const ParametrosPixForm = lazy(() => import("./pages/parametrosPix/ParametrosPixForm"));
const UsuariosNfseBox = lazy(() => import("./pages/cpbs/UsuariosNfse/UsuariosNfseBox"));
const UsuariosNfseForm = lazy(() => import("./pages/cpbs/UsuariosNfse/UsuariosNfseForm"));
const FundamentoLegalBox = lazy(() => import("./pages/fundamentoLegal/fundamentoLegalBox"));
const FundamentoLegalForm = lazy(() => import("./pages/fundamentoLegal/fundamentoLegalForm"));
const TransferenciaImovel = lazy(() => import("./pages/transferenciaImovel/TransferenciaImovel"));
const AlvaraEmLote = lazy(() => import("./pages/lancamentos/AlvaraEmLote"));
const RestaurarNfseBox = lazy(() => import("./pages/RestaurarNfseBox"));
const CancelarEscrituracaoBox = lazy(() => import("./pages/CancelarEscrituracaoBox"));
const SituacaoDiatBoxNovo = lazy(() => import("./pages/SituacaoDiat/SituacaoDiatBoxNovo"));
const SituacaoDiatFormNovo = lazy(() => import("./pages/SituacaoDiat/SituacaoDiatFormNovo"));
const ConferenciaNumeroComplemento = lazy(() => import("./pages/ConferenciaNumeroComplemento"));
const ConferenciaLogradouro = lazy(() => import("./pages/ConferenciaLogradouro"));
const UnificarCadastrosForm = lazy(() => import("./pages/UnificarCadastrosForm.js"));
const AcessosNfseAntigaBox = lazy(() => import("./pages/AcessosNfseAntigaBox.js"));
const AdnNfeBox = lazy(() => import("./pages/adn/AdnNfeBox"));
const ImportarCnpjsTse = lazy(() => import("./pages/eleicoes/ImportarCnpjsTse"));
const SinterSincronizacaoBox = lazy(() => import("./pages/sinter/SinterSincronizacaoBox"));
const SinterConfiguracao = lazy(() => import("./pages/sinterConfiguracao/SinterConfiguracao"));
const SinterCargaItbiBox = lazy(() => import("./pages/sinter/SinterCargaItbiBox"));
const SinterSaneamento = lazy(() => import("./pages/sinterSaneamento/SinterSaneamento"));
const SaldoDividaAtiva = lazy(() => import("./pages/saldoDividaAtiva/SaldoDividaAtiva"));
const SinterDeParaScore = lazy(() => import("./pages/sinterDeParaScore/SinterDeParaScore"));
const PortalContribuinte = lazy(() => import("./pages/portalContribuinte/PortalContribuinte"));
const LogradourosTipos = lazy(() => import("./pages/logradourosTipos/LogradourosTipos"));

export default [
  {
    path: "/display-data",
    component: DisplayDataPage,
  },
  {
    path: "/profile/:id?",
    component: ProfilePage,
  },
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/juros",
    perfis: ["trimap", "prefeitura"],
    component: JurosBox,
    recursoId: 1,
  },
  {
    path: "/calendarioIss",
    perfis: ["trimap", "prefeitura"],
    component: CalendarioIssBox,
    recursoId: 2,
  },
  {
    path: "/multas",
    perfis: ["trimap", "prefeitura"],
    component: MultasBox,
    recursoId: 3,
  },
  {
    path: "/categorias_cpbs",
    perfis: ["trimap", "prefeitura"],
    component: CategoriaCpbxBox,
    recursoId: 4,
  },
  {
    tipo: "grade-form",
    path: "/servicosiss",
    perfis: ["trimap", "prefeitura"],
    component: ServicosIssBox,
    componentForm: ServicosIssForm,
    recursoId: 5,
  },
  {
    tipo: "grade-form",
    path: "/contadores",
    perfis: ["trimap", "prefeitura"],
    component: ContadorBox,
    componentForm: ContadorForm,
    recursoId: 6,
  },
  {
    path: "/bairros",
    perfis: ["trimap", "prefeitura"],
    component: BairrosBox,
    recursoId: 7,
  },
  {
    path: "/distritos",
    perfis: ["trimap", "prefeitura"],
    component: DistritosBox,
    recursoId: 8,
  },
  {
    path: "/escores",
    perfis: ["trimap", "prefeitura"],
    component: EscoresBox,
    recursoId: 9,
  },
  {
    path: "/aliquotas_iptu",
    perfis: ["trimap", "prefeitura"],
    component: AliquotasIPTUBox,
    recursoId: 10,
  },
  {
    path: "/logradouros",
    perfis: ["trimap", "prefeitura"],
    component: LogradourosBox,
    recursoId: 11,
  },
  {
    path: "/loteamentos",
    perfis: ["trimap", "prefeitura"],
    component: LoteamentosBox,
    recursoId: 12,
  },
  {
    path: "/colaboradores",
    perfis: ["trimap", "prefeitura"],
    component: ColaboradoresBox,
    recursoId: 13,
  },
  {
    path: "/categorias_servicos",
    perfis: ["trimap", "prefeitura"],
    component: CategoriasAliquotasIssBox,
    recursoId: 14,
  },
  {
    path: "/situacoes_cpbs",
    perfis: ["trimap", "prefeitura"],
    component: SituacoesCadastraisCpbsBox,
    recursoId: 15,
  },
  {
    path: "/regimes_cpbs",
    perfis: ["ch"],
    component: RegimesTributariosBox,
    recursoId: 16,
  },
  {
    path: "/tipos_recolhimento_iss",
    perfis: ["ch"],
    component: TiposRecolhimentoBox,
    recursoId: 17,
  },
  {
    path: "/graus_instrucao",
    perfis: ["trimap", "prefeitura"],
    component: GrausInstrucaoBox,
    recursoId: 18,
  },
  {
    path: "/naturezas_juridicas",
    perfis: ["ch"],
    component: NaturezasJuridicasBox,
    recursoId: 19,
  },
  {
    path: "/cnaes",
    perfis: ["ch"],
    component: CnaesBox,
    recursoId: 20,
  },
  {
    path: "/feriados",
    perfis: ["trimap", "prefeitura"],
    component: FeriadosBox,
    recursoId: 21,
  },
  {
    tipo: "grade-form",
    path: "/prefeituras",
    perfis: ["trimap"],
    component: PrefeituraBox,
    componentForm: PrefeituraForm,
    recursoId: 22,
  },
  {
    tipo: "grade-form",
    path: "/usuarios",
    perfis: ["trimap"],
    component: UsuariosBox,
    componentForm: UsuariosForm,
    recursoId: 23,
  },
  {
    path: "/servicoslcp",
    perfis: ["trimap", "prefeitura"],
    component: ServicosLCPBox,
    recursoId: 24,
  },
  {
    path: "/categoriaslcp",
    perfis: ["trimap", "prefeitura"],
    component: CategoriasLCPBox,
    recursoId: 25,
  },
  {
    path: "/naturezaoperacao",
    perfis: ["trimap", "prefeitura"],
    component: NaturezasOperacaoBox,
    recursoId: 26,
  },
  {
    path: "/seriesnf",
    perfis: ["trimap", "prefeitura"],
    component: SerieNotaFiscalBox,
    recursoId: 27,
  },
  {
    path: "/retencoesexternas",
    perfis: ["trimap", "prefeitura"],
    component: RetencaoExternaBox,
    recursoId: 28,
  },
  {
    path: "/leis",
    perfis: ["trimap", "prefeitura"],
    component: CadastrarLeisBox,
    recursoId: 29,
  },
  {
    path: "/documentosretencoes",
    perfis: ["trimap", "prefeitura"],
    component: DocumentosRetencaoBox,
    recursoId: 30,
  },
  {
    tipo: "grade-form",
    path: "/cpbs",
    perfis: ["trimap", "prefeitura"],
    component: CpbsBox,
    componentForm: CpbsForm,
    recursoId: 31,
  },
  {
    tipo: "grade-form",
    path: "/valoredificado",
    perfis: ["trimap", "prefeitura"],
    component: ValorEdificadoBox,
    componentForm: ValorEdificadoForm,
    recursoId: 32,
  },
  {
    path: "/agentesrecebedores",
    perfis: ["trimap", "prefeitura"],
    component: AgentesRecebedoresBox,
    recursoId: 33,
  },
  {
    path: "/contascosif",
    perfis: ["trimap", "prefeitura"],
    component: ContasCosifBox,
    recursoId: 34,
  },
  {
    tipo: "grade-form",
    path: "/contascosif",
    perfis: ["trimap", "prefeitura"],
    component: ContasCosifBox,
    componentForm: ContasCosifForm,
    recursoId: 34,
  },
  {
    path: "/statusprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: StatusProtocoloBox,
    recursoId: 35,
  },
  {
    tipo: "grade-form",
    path: "/statusprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: StatusProtocoloBox,
    componentForm: StatusProtocoloForm,
    recursoId: 35,
  },
  {
    path: "/setoratendimentoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: SetorAtendimentoProtocoloBox,
    recursoId: 36,
  },
  {
    tipo: "grade-form",
    path: "/setoratendimentoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: SetorAtendimentoProtocoloBox,
    componentForm: SetorAtendimentoProtocoloForm,
    recursoId: 36,
  },
  {
    path: "/tipoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: TipoProtocoloBox,
    recursoId: 37,
  },
  {
    tipo: "grade-form",
    path: "/tipoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: TipoProtocoloBox,
    componentForm: TipoProtocoloForm,
    recursoId: 37,
  },
  {
    path: "/recursos",
    perfis: ["trimap", "prefeitura"],
    component: RecursoBox,
    recursoId: 38,
  },
  {
    tipo: "grade-form",
    path: "/parametros_livro_diat",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosLivroBox,
    componentForm: ParametrosLivroForm,
    recursoId: 39,
  },
  {
    path: "/livros-diat",
    perfis: ["trimap", "prefeitura"],
    component: GerarLivroDiat,
  },
  {
    path: "/extratos-debitos-diat",
    perfis: ["trimap", "prefeitura"],
    component: ExtratoDebitosDiatBox,
  },
  {
    path: "/usuariosprefeitura",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosPrefeituraBox,
  },
  {
    path: "/permissoes",
    perfis: ["trimap", "prefeitura"],
    component: PermissoesBox,
  },
  {
    path: "/auditoria",
    perfis: ["trimap", "prefeitura"],
    component: AuditoriaBox,
  },
  {
    tipo: "grade-form",
    path: "/recursos",
    perfis: ["trimap", "prefeitura"],
    component: RecursoBox,
    componentForm: RecursoForm,
  },
  {
    path: "/gruporecurso",
    perfis: ["trimap", "prefeitura"],
    component: GrupoRecursoBox,
  },
  {
    tipo: "grade-form",
    path: "/gruporecurso",
    perfis: ["trimap", "prefeitura"],
    component: GrupoRecursoBox,
    componentForm: GrupoRecursoForm,
  },
  {
    tipo: "grade-form",
    path: "/textoscda",
    perfis: ["trimap", "prefeitura"],
    component: TextoCdaBox,
    componentForm: TextoCdaForm,
    recursoId: 42,
  },
  {
    path: "/tipos_veiculos",
    perfis: ["trimap", "prefeitura"],
    component: TiposVeiculosBox,
    recursoId: 43
  },
  {
    tipo: "grade-form",
    path: "/situacoesdiat",
    perfis: ["trimap", "prefeitura"],
    component: SituacaoDiatBoxNovo,
    componentForm: SituacaoDiatFormNovo,
    recursoId: 44
  },
  {
    path: "/processar_arquivo",
    perfis: ["trimap", "prefeitura"],
    component: EnviarArquivoProcessamento,
    recursoId: 45
  },
  {
    tipo: "grade-form",
    path: "/lancamentoiptu",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoIptu,
    componentForm: LancamentoIptuForm,
    recursoId: 46
  },
  {
    path: "/acompanhar_iptu/:id",
    perfis: ["trimap", "prefeitura"],
    component: AcompanharIptu,
  },
  {
    tipo: "grade-form",
    path: "/parametrosiptu",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosIptuBox,
    componentForm: ParametrosIptuForm,
    recursoId: 47
  },
  {
    path: "/imprimiriptu",
    perfis: ["trimap", "prefeitura"],
    component: ImprimirIptu,
    recursoId: 48
  },
  {
    tipo: "grade-form",
    path: "/tiposdenotificacoes",
    perfis: ["trimap", "prefeitura"],
    component: TipoNotificacaoBox,
    componentForm: TipoNotificacaoForm,
    recursoId: 49
  },
  {
    tipo: "grade-form",
    path: "/veiculos",
    perfis: ["trimap", "prefeitura"],
    component: VeiculosBox,
    componentForm: VeiculosForm,
    recursoId: 50
  },
  {
    tipo: "grade-form",
    path: "/contasbancarias",
    perfis: ["trimap", "prefeitura"],
    component: ContasBancariasBox,
    componentForm: ContasBancariasForm,
    recursoId: 51
  },
  {
    tipo: "grade-form",
    path: "/receitas",
    perfis: ["trimap", "prefeitura"],
    component: ReceitasBox,
    componentForm: ReceitasForm,
    recursoId: 52
  },
  {
    path: "/unidadesfiscais",
    perfis: ["trimap", "prefeitura"],
    component: UnidadeFiscalBox,
    recursoId: 53
  },
  {
    tipo: "grade-form",
    path: "/contribuintes",
    perfis: ["trimap", "prefeitura"],
    component: ContribuinteBox,
    componentForm: ContribuinteForm,
    recursoId: 54
  },
  {
    tipo: "grade-form",
    path: "/refis",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosRefisBox,
    componentForm: ParametrosRefisForm,
    recursoId: 55
  },
  {
    path: "/indiceprecos",
    perfis: ["trimap", "prefeitura"],
    component: IndicePrecosBox,
    recursoId: 56
  },
  {
    path: "/fatores-correcao-monetaria",
    perfis: ["trimap", "prefeitura"],
    component: FatoresCorrecaoMonetariaBox
  },
  {
    tipo: "grade-form",
    path: "/segmentos",
    perfis: ["trimap", "prefeitura"],
    component: SegmentosBox,
    componentForm: SegmentosForm,
    recursoId: 57
  },
  {
    tipo: "grade-form",
    path: "/fatorescorretivos",
    perfis: ["trimap", "prefeitura"],
    component: FatoresCorretivosBox,
    componentForm: FatoresCorretivosForm,
    recursoId: 58
  },
  {
    tipo: "grade-form",
    path: "/taxas",
    perfis: ["trimap", "prefeitura"],
    component: TaxasBox,
    componentForm: TaxasForm,
    recursoId: 59
  },
  {
    tipo: "grade-form",
    path: "/tipocertidao",
    perfis: ["trimap", "prefeitura"],
    component: ConfiguracaoCndBox,
    componentForm: ConfiguracaoCndForm,
    recursoId: 60
  },
  {
    path: "/motivosisencaoiptu",
    perfis: ["trimap", "prefeitura"],
    component: MotivoIsensaoIptuBox,
    recursoId: 61
  },
  {
    tipo: "rotas-imovel",
    path: "/imoveis",
    perfis: ["trimap", "prefeitura"],
    component: ImovelBox,
    componentForm: ImovelForm,
    componentFormTerreno: FormEditTerreno,
    componentFormEdificacao: FormEditEdificacao,
    componentFormCalculoIptu: CalculoIptu,
    recursoId: 62
  },
  {
    tipo: "grade-form",
    path: "/diat",
    perfis: ["trimap", "prefeitura"],
    component: DiatBox,
    componentForm: DiatForm,
    recursoId: 63
  },
  {
    tipo: "grade-form",
    path: "/notificacaodiat",
    perfis: ["trimap", "prefeitura"],
    component: NotificacaoDiatBox,
    componentForm: NotificacaoDiatForm,
    recursoId: 64
  },
  {
    tipo: "grade-form",
    path: "/entreganotificaodiat",
    perfis: ["trimap", "prefeitura"],
    component: EntregaNotificacaoDiatBox,
    componentForm: EntregaNotificacaoDiatForm,
    recursoId: 65
  },

  {
    tipo: "grade-form",
    path: "/tipos_alvara_construcao",
    perfis: ["trimap", "prefeitura"],
    component: TiposAlvaraConstrucaoBox,
    componentForm: TiposAlvaraConstrucaoForm,
    recursoId: 66
  },
  {
    tipo: "grade-form",
    path: "/alvarasdiversos",
    perfis: ["trimap", "prefeitura"],
    component: TipoAlvaraDiversoBox,
    componentForm: TipoAlvaraDiversoForm,
    recursoId: 67
  },
  {
    tipo: "grade-form",
    path: "/cnaeprefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CnaePrefeituraBox,
    componentForm: CnaePrefeituraForm,
    recursoId: 68
  },
  {
    tipo: "grade-form",
    path: "/lcp116prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: Lcp116PrefeituraBox,
    componentForm: Lcp116PrefeituraForm,
    recursoId: 69
  },
  {
    tipo: "grade-form",
    path: "/cpbs_socios/:inscricao",
    perfis: ["trimap", "prefeitura"],
    component: SociosBox,
    componentForm: SociosForm,
    recursoId: 70
  },
  {
    tipo: "grade-form",
    path: "/formulasiptu",
    perfis: ["trimap", "prefeitura"],
    component: FormulasBox,
    componentForm: FormulasForm,
    recursoId: 71
  },
  {
    tipo: "grade-form",
    path: "/precopublico",
    perfis: ["trimap", "prefeitura"],
    component: PrecoPublicoBox,
    componentForm: PrecoPublicoForm,
    recursoId: 72
  },
  {
    tipo: "grade-form",
    path: "/permissionarios",
    perfis: ["trimap", "prefeitura"],
    component: PermissionarioBox,
    componentForm: PermissionarioForm,
    recursoId: 73
  },
  {
    tipo: "grade-form",
    path: "/responsaveistecnicos",
    perfis: ["trimap", "prefeitura"],
    component: ResponsavelTecnicoBox,
    componentForm: ResponsavelTecnicoForm,
    recursoId: 74
  },
  {
    tipo: "grade-form",
    path: "/certidaonegativa",
    perfis: ["trimap", "prefeitura"],
    component: CertidaoNegativaBox,
    componentForm: CertidaoNegativaForm,
    recursoId: 75
  },
  {
    tipo: "grade-form",
    path: "/itbi",
    perfis: ["trimap", "prefeitura"],
    component: ItbiBox,
    componentForm: ItbiForm,
    recursoId: 76
  },
  {
    tipo: "grade-form",
    path: "/lancamentotaxas",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoTaxasBox,
    componentForm: LancamentoTaxasForm,
    recursoId: 77
  },
  {
    path: "/nfavulsa",
    perfis: ["trimap", "prefeitura"],
    component: NotaFiscalAvulsaBox,
    recursoId: 78
  },
  {
    path: "/emissao_nf_avulsa/:id?",
    perfis: ["trimap", "prefeitura"],
    component: NotaFiscalAvulsaForm,
    recursoId: 78
  },
  {
    tipo: "grade-form",
    path: "/cda",
    perfis: ["trimap", "prefeitura"],
    component: CdaBox,
    componentForm: CdaForm,
    recursoId: 79
  },
  {
    path: "/certidaonegativa/automatica",
    perfis: ["trimap", "prefeitura"],
    component: CertidaoNegativaAutomatica,
    recursoId: 80
  },
  {
    path: "/habitese/:id?",
    perfis: ["trimap", "prefeitura"],
    component: Habitese,
    recursoId: 81
  },
  {
    path: "/categorialcp116prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CategoriaLcp116PrefeituraBox,
    recursoId: 86
  },
  {
    path: "/cubo_imoveis",
    perfis: ["trimap", "prefeitura"],
    component: CuboImoveis,
    recursoId: 87
  },
  /*
  Rota removida porque componente está comentado
  {
    path: "/relatorios",
    perfis: ["trimap", "prefeitura"],
    component: RelatoriosDisplay,
    recursoId: 88,
  },
  */
  {
    path: "/arrecadacoes",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoPopup,
    recursoId: 89
  },
  {
    path: "/imovel_inativo",
    perfis: ["trimap", "prefeitura"],
    component: ImoveisInativosPopup,
    recursoId: 90
  },
  {
    path: "/imprimir_imovel",
    perfis: ["trimap", "prefeitura"],
    component: ImprimirImoveisPopup,
    recursoId: 91
  },
  {
    path: "/relatorios_filtros",
    perfis: ["trimap", "prefeitura"],
    component: RelatoriosFiltros,
    recursoId: 92
  },
  {
    path: "/alvara_veiculo/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraVeiculoForm,
    recursoId: 93
  },
  {
    path: "/alvara_funcionamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraFuncionamentoForm,
    recursoId: 94
  },
  {
    path: "/alvara_sanitario/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraFuncionamentoForm,
    recursoId: 95
  },
  {
    path: "/dams",
    perfis: ["trimap", "prefeitura"],
    component: DamsBox,
    recursoId: 96
  },
  {
    path: "/cefs",
    perfis: ["trimap", "prefeitura"],
    component: CefsBox,
    recursoId: 97
  },
  {
    path: "/nfse_grade",
    perfis: ["trimap", "prefeitura"],
    component: NfseGradeBox,
    recursoId: 98
  },
  {
    path: "/adn-nfe",
    perfis: ["trimap", "prefeitura"],
    component: AdnNfeBox
  },
  {
    path: "/alvaras",
    perfis: ["trimap", "prefeitura"],
    component: AlvarasBox,
    recursoId: 99
  },
  {
    path: "/baixa_manual",
    perfis: ["trimap", "prefeitura"],
    component: BaixaManualForm,
    recursoId: 100
  },
  {
    path: "/baixarnotas",
    perfis: ["trimap", "prefeitura"],
    component: BaixarNotas,
    recursoId: 101
  },
  {
    path: "/tipos_uso_logradouro_publico",
    perfis: ["trimap", "prefeitura"],
    component: TipoUsoLogradouroBox,
    recursoId: 102
  },
  {
    path: "/alvara_horario_especial/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraHorarioEspecial,
    recursoId: 103
  },
  {
    path: "/alvara_logradouro_publico/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoUsoLogradouroPublico,
    recursoId: 104
  },
  {
    path: "/alvara_publicidade/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraPublicidade,
    recursoId: 105
  },
  {
    path: "/alvara_diversos/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraDiversos,
    recursoId: 106
  },
  {
    path: "/alvara_construcao/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraConstrucao,
    recursoId: 107
  },
  {
    path: "/lancamento_info",
    perfis: ["ch", "prefeitura"],
    recursoId: 108
  },
  {
    path: "/negociacaodiat",
    perfis: ["trimap", "prefeitura"],
    component: NegociacaoDiat,
    recursoId: 109
  },
  {
    path: "/qualificacaosocios",
    perfis: ["trimap", "prefeitura"],
    component: QualificacaoSociosBox,
    recursoId: 110
  },
  {
    path: "/cpbs_cnaes/:inscricao",
    perfis: ["trimap", "prefeitura"],
    component: CnaesCpbsBox,
    recursoId: 111
  },
  {
    path: "/configs",
    perfis: ["trimap", "prefeitura"],
    component: ConfigBox,
    recursoId: 112
  },
  {
    path: "/acompanhardiat",
    perfis: ["trimap", "prefeitura"],
    component: AcompanhamentoDiatBox,
    recursoId: 113
  },
  {
    path: "/calculo-divida-ativa",
    perfis: ["trimap", "prefeitura"],
    component: CalculoManualDiatBox,
    recursoId: 114
  },
  {
    tipo: "grade-form",
    path: "/calculo-divida-ativa",
    perfis: ["trimap", "prefeitura"],
    component: CalculoManualDiatBox,
    componentForm: CalculoManualDiatForm,
    recursoId: 114
  },
  {
    path: "/detalhelancamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: DetalheLanchamento,
    recursoId: 115
  },
  {
    path: "/acompanharprocessamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AcompanharProcessamento,
    recursoId: 116
  },
  {
    path: "/listarprocessamentos/",
    perfis: ["trimap", "prefeitura"],
    component: ListarProcessamento,
    recursoId: 117
  },
  {
    path: "/detalhenfavulsa/:id?",
    perfis: ["trimap", "prefeitura"],
    component: DetalheNFAvulsa,
    recursoId: 118
  },
  {
    path: "/conferenciaacordos",
    perfis: ["trimap", "prefeitura"],
    component: ConferenciaAcordo,
    recursoId: 119
  },
  {
    path: "/prescrever_diat",
    perfis: ["trimap", "prefeitura"],
    component: PrescricaoDiat,
    recursoId: 120
  },
  {
    path: "/faturamento_permissionarios",
    perfis: ["trimap", "prefeitura"],
    component: FaturamentoPermissionarios,
    recursoId: 121
  },
  {
    path: "/protocolo_entrega_notificacao",
    perfis: ["trimap", "prefeitura"],
    component: ProtocoloEntregaNotificacao,
    recursoId: 122
  },
  {
    path: "/criar_processamento",
    perfis: ["trimap", "prefeitura"],
    component: CadastroProcessamentosTeste,
    recursoId: 123
  },
  {
    path: "/analises",
    perfis: ["trimap", "prefeitura"],
    component: AnaliseGraficos,
    recursoId: 124
  },
  {
    path: "/enviar-acessos-em-massa",
    perfis: ["trimap"],
    component: EnviarAcessosEmMassa,
    recursoId: 125
  },
  {
    path: "/arquivos-e-boletos",
    perfis: ["trimap", "prefeitura"],
    component: ArquivosEBoletos,
    recursoId: 126
  },
  {
    path: "/ferramentas-nfse",
    perfis: ["trimap"],
    component: FerramentasNFSe,
    recursoId: 127
  },
  {
    path: "/menu-configuracoes",
    perfis: ["trimap", "prefeitura"],
    component: MenuConfiguracoes,
    recursoId: 128
  },
  {
    path: "/inscricao-manual",
    perfis: ["trimap", "prefeitura"],
    component: DiatFormNovo,
    recursoId: 129
  },
  {
    path: "/enviar-arquivos/:tipo",
    perfis: ["trimap", "prefeitura"],
    component: UploadFiles,
    recursoId: 130
  },
  {
    path: "/extrato-debitos",
    perfis: ["trimap", "prefeitura"],
    component: ExtratoDebitos,
    recursoId: 131
  },
  {
    path: "/nfse",
    perfis: ["trimap", "prefeitura"],
    component: NfseBox,
    recursoId: 132
  },
  {
    path: "/painel-imobiliario",
    perfis: ["trimap", "prefeitura"],
    component: PainelImobiliarioBox,
    recursoId: 133
  },
  {
    path: "/usuarios-prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosPrefeituraBox,
    recursoId: 134
  },
  {
    path: "/iss-fixo",
    perfis: ["trimap", "prefeitura"],
    component: IssFixo,
    recursoId: 135
  },
  {
    path: "/simulacoes",
    perfis: ["trimap", "prefeitura"],
    component: Simulacoes,
  },
  {
    path: "/indicestrimap",
    perfis: ["trimap", "prefeitura"],
    component: IndicesTrimapBox,
  },
  {
    path: "/calendarioindicestrimap",
    perfis: ["trimap", "prefeitura"],
    component: CalendarioIndicesTrimapBox,
  },
  {
    path: "/graficos",
    perfis: ["trimap", "prefeitura"],
    component: Graficos,
  },

  {
    path: "/uploadfiles",
    perfis: ["trimap", "prefeitura"],
    component: UploadFiles,
  },

  {
    path: "/painel_iss",
    perfis: ["trimap", "prefeitura"],
    component: PainelIssBox,
  },

  {
    path: "/remessa_boletos",
    perfis: ["trimap", "prefeitura"],
    component: RegistrarBoletosBox,
  },
  {
    tipo: "grade-form",
    path: "/parametros_pix",
    perfis: ["trimap"],
    component: ParametrosPixBox,
    componentForm: ParametrosPixForm
  },
  {
    tipo: "grade-form",
    path: "/fundamento_legal",
    perfis: ["trimap", "prefeitura"],
    component: FundamentoLegalBox,
    componentForm: FundamentoLegalForm
  },
  {
    path: "/transferencia_imovel",
    perfis: ["trimap", "prefeitura"],
    component: TransferenciaImovel,

    tipo: "grade-form",
    path: "/alvara-em-lote",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraEmLote,
  },
  {
    path: "/restaurar-nf",
    perfis: ["trimap"],
    component: RestaurarNfseBox
  },
  {
    path: "/cancelar-escrituracao",
    perfis: ["trimap"],
    component: CancelarEscrituracaoBox
  },
  {
    path: "/conf_numero_complemento",
    perfis: ["trimap"],
    component: ConferenciaNumeroComplemento
  },
  {
    path: "/conf_logradouro",
    perfis: ["trimap"],
    component: ConferenciaLogradouro
  },
  {
    path: "/transferencia-anual-diat",
    perfis: ["trimap", "prefeitura"],
    component: TransferenciaAnualDiat,
  },
  {
    path: "/unificacaocadastros",
    perfis: ["trimap", "prefeitura"],
    component: UnificarCadastrosForm,
  },
  {
    path: "/premigracaocpbs",
    perfis: ["trimap", "prefeitura"],
    component: PreMigracaoCpbsBox,
  },
  {
    tipo: "grade-form",
    path: "/imovel-bci",
    perfis: ["trimap", "prefeitura"],
    component: ImobelBciBox,
    componentForm: ImovelBciForm,
  },
  {
    path: "/imovel-bci/editar/fatores/:id",
    perfis: ["trimap", "prefeitura"],
    component: ImovelBciFatores,
  },
  {
    tipo: "grade-form",
    path: "/cadastro-modelos",
    perfis: ["trimap"],
    component: CadastroModelosBox,
    componentForm: CadastroModelosForm,
  },
  {
    tipo: "grade-form",
    path: "/cadastro-modelos-prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CadastroModelosPrefeituraBox,
    componentForm: CadastroModelosPrefeituraForm,
  },
  {
    path: "/certidaonegativa/:id",
    perfis: ["trimap", "prefeitura"],
    component: VisualizarCertidao,
  },
  {
    tipo: "grade-form",
    path: "/encerramento-fiscal",
    perfis: ["trimap", "prefeitura"],
    component: EncerramentoFiscalManualBox,
    componentForm: EncerramentoFiscalManualForm,
  },
  {
    tipo: "grade-form",
    path: "/usuario_nfse/:id?",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosNfseBox,
    componentForm: UsuariosNfseForm,
  },
  {
    path: "/acompanhamento-simples-nacional",
    perfis: ["trimap", "prefeitura"],
    component: AcompanhamentoSNBox,
  },
  {
    path: "/procedimento-diat",
    perfis: ["trimap", "prefeitura"],
    component: ProcedimentoDiat,
  },
  {
    path: "/gerar-livro-diat",
    perfis: ["trimap", "prefeitura"],
    component: GerarLivro,
  },
  {
    path: "/simples-nacional",
    perfis: ["trimap", "prefeitura"],
    component: SimplesNacionalBox,
  },
  {
    path: "/protocolos",
    perfis: ["trimap", "prefeitura"],
    component: ProtocolosBox,
  },
  {
    tipo: "grade-form",
    path: "/acessos-nfse-antiga",
    perfis: ["trimap"],
    component: AcessosNfseAntigaBox
  },
  {
    path: "/importar-cnpjs-tse",
    perfis: ["trimap"],
    component: ImportarCnpjsTse,
  },
  {
    path: "/sinter-configuracao",
    perfis: ["trimap", "prefeitura"],
    component: SinterConfiguracao,
  },
  {
    path: "/sinter-carga-itbi",
    perfis: perfisDaRota(["trimap"]),
    component: SinterCargaItbiBox,
  },
  {
    path: "/relatorios/:categoria?",
    perfis: ["trimap", "prefeitura"],
    component: CentralRelatorios,
  },
  {
    path: "/sinter-sincronizacao",
    perfis: ["trimap", "prefeitura"],
    component: SinterSincronizacaoBox,
  },
  {
    path: "/sinter-saneamento",
    perfis: ["trimap", "prefeitura"],
    component: SinterSaneamento,
  },
  {
    path: "/divida-ativa/saldo/:dividaId",
    perfis: ["trimap", "prefeitura"],
    component: SaldoDividaAtiva,
  },
  {
    path: "/portal-contribuinte",
    perfis: perfisDaRota(["trimap"]),
    component: PortalContribuinte,
  },
  {
    path: "/sinter-de-para-score",
    perfis: ["trimap", "prefeitura"],
    component: SinterDeParaScore,
  },
  {
    path: "/logradouros-tipos",
    perfis: ["trimap", "prefeitura"],
    component: LogradourosTipos,
  },
  {
    tipo: "grade-form",
    path: "/contribuintes-novo",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: ContribuintesNovoBox,
    componentForm: ContribuinteNovoFormulario,
  },
  {
    path: "/protesto-parametros",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: ParametrosProtestoBox,
  },
  {
    path: "/protesto-municipios",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: MunicipiosHomologadosBox,
  },
  {
    path: "/protesto-registro-integracao",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: RegistroIntegracaoBox,
  },
  {
    path: "/protesto-pedidos",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: PedidosProtestoBox,
  },
  {
    path: "/protesto-remessas",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: RemessasProtestoBox,
  },
  {
    path: "/protesto-acompanhamento",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: AcompanhamentoProtestoBox,
  },
  {
    path: "/protesto-encerramentos",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: EncerramentosProtestoBox,
  },
  {
    path: "/protesto-motivos-encerramento",
    perfis: perfisDaRota(["trimap", "prefeitura"]),
    component: MotivosEncerramentoBox,
  },
];
